<script lang="ts">
  import { fade } from 'svelte/transition';
  import { notification, clearNotif } from '../stores/notifications';
</script>

{#if $notification?.text}
  <div class={`notification px-6 py-5 is-size-3 ${$notification.type}`} transition:fade>
    <button class="delete" on:click={clearNotif}></button>
    {$notification.text}
  </div>
{/if}

<style lang="scss">

  .notification {
    position: fixed;
    top: 1rem;
    right: 1rem;
  }
</style>